import { Col, Form, Input, Row, Radio, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React from "react";
import { useTranslation } from 'react-i18next';

function ProfilePage({ userInfo, setUserInfo, onImageChange }) {
  const { t } = useTranslation();
  const [preview, setPreview] = React.useState(
    userInfo?.profile_image || userInfo?.avatar || ""
  );

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const beforeUpload = async (file) => {
    const base64 = await toBase64(file);
    setPreview(base64);
    setUserInfo((inf) => ({ ...inf, profile_image: base64 }));
    if (onImageChange) {
      onImageChange(file);
    }
    return false;
  };

  const uploadButton = (
    <div className="profile-upload-button">
      <PlusOutlined />
      <div className="profile-upload-text">{t('settings.profile.upload')}</div>
    </div>
  );

  return (
    <Form
      layout="vertical"
      defaultValue={userInfo}
      initialValues={userInfo}
      onValuesChange={(changedValues) => {
        setUserInfo((inf) => {
          return { ...inf, ...changedValues };
        });
      }}
    >
      {/* Photo on top */}
      <Row gutter={25}>
        <Col span={24}>
          <div className="profile-photo-container">
            <div className="profile-photo-label">{t('settings.profile.photo')}</div>
            <div className="profile-photo-upload">
              <Upload
                listType="picture-card"
                showUploadList={false}
                beforeUpload={beforeUpload}
                accept="image/*"
              >
                {preview ? (
                  <img
                    src={preview}
                    alt="avatar"
                    className="profile-photo-preview"
                  />
                ) : (
                  uploadButton
                )}
              </Upload>
            </div>
          </div>
        </Col>
      </Row>

      {/* Details below photo */}
      <Row gutter={25}>
        <Col span={24}>
          <Row gutter={25}>
            <Col span={12} xl={12} md={12} sm={24} xs={24}>
              <Form.Item name="first_name" label={t('settings.profile.firstName')}>
                <Input className="setting-input" placeholder={t('settings.profile.firstName')} />
              </Form.Item>
            </Col>
            <Col span={12} xl={12} md={12} sm={24} xs={24}>
              <Form.Item name="last_name" label={t('settings.profile.lastName')}>
                <Input className="setting-input" placeholder={t('settings.profile.lastName')} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={25}>
            <Col span={12} xl={12} md={12} sm={24} xs={24}>
              <Form.Item name="email" label={t('settings.profile.email')}>
                <Input className="setting-input" placeholder={t('settings.profile.email')} />
              </Form.Item>
            </Col>
            <Col span={12} xl={12} md={12} sm={24} xs={24}>
              <Form.Item name="number" label={t('settings.profile.phone')}>
                <Input
                  className="setting-input"
                  placeholder={t('settings.profile.phone')}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={25}>
            <Col span={12} xl={12} md={12} sm={24} xs={24}>
              <Form.Item name="gender" label={t('settings.profile.gender')}>
                <Radio.Group>
                  <Radio value="male">{t('settings.profile.male')}</Radio>
                  <Radio value="female">{t('settings.profile.female')}</Radio>
                  <Radio value="other">{t('settings.profile.other')}</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={12} xl={12} md={12} sm={24} xs={24}>
              <Form.Item name="address" label={t('settings.profile.address')}>
                <Input className="setting-input" placeholder={t('settings.profile.address')} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={25}>
            <Col span={12} xl={12} md={12} sm={24} xs={24}>
              <Form.Item name="company" label={t('settings.profile.company')}>
                <Input
                  className="setting-input"
                  placeholder={t('settings.profile.company')}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
}

export default ProfilePage;
